import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { hasInputProcessTab } from "@/features/project/lib/project-tabs";

export const Route = createFileRoute(
  "/_protected/corporate-finance/projects/$id/account-mapping",
)({
  validateSearch: z.object({
    mappingStatus: z
      .enum(["classified", "unclassified", "modified"])
      .optional(),
  }),
  beforeLoad: ({ context: { hierarchy, appInfo }, params, search }) => {
    const active =
      hierarchy.children.find((child) => child.id === search.entityProjectId) ??
      hierarchy.root;

    const features = Array.from(
      new Set([...hierarchy.root.features, ...active.features]),
    );

    if (
      !hasInputProcessTab({
        module: "corporate-finance",
        features,
        appCapabilities: appInfo ?? { document_intelligence: false },
        classificationTemplateIds: active.classification_template_ids,
      })
    ) {
      throw redirect({
        to: "/corporate-finance/projects/$id",
        params: { id: params.id },
      });
    }
  },
});
